import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import type { App } from 'vue'
export const useVueVirtualScroller = (app: App) => {
    app.use(VueVirtualScroller)
}